import {observer} from "mobx-react";
import React from "react"
import styles from "../components/style.module.sass"
import {FlexRowSpaceBetween} from "../../../../../components/containers/containers";
import PriceComponent from "../../../../../components/priceComponent";
import {PlusPrimaryPinkButton} from "../../../../../components/buttons/plusButton";
import {useStores} from "../../../../../hooks";
import useOpenMenuItem from "../../../../../hooks/useOpenMenuItem";
import {MediaType, MenuItem} from "../../../../../services/menu/models";
import {Trans, useTranslation} from "react-i18next";
import PlusMinusWidget from "../../../../../components/plusMinusWidget";
import LazyImage from "../../../../../components/imageLazyLoader";
import time from "../../header/assets/time.svg"
import Icon3d from "../../../../../assets/3d.svg";
import OldPriceLabelBadge, {useOldPriceLabel} from "../../../../../components/oldPriceLabelBadge";
import ItemBadges from "../../../../../components/itemBadges";
import {resolveItemBadges} from "../../../../../components/itemBadges/libs";
import classNames from "classnames";

interface IProps {
    item: MenuItem,
}

const MenuItemComponent = ({ item }: IProps) => {
    const { cartStore, menuStore } = useStores();
    const isInCart = cartStore.isInCart(item.id);
    const { i18n, t } = useTranslation();
    const locale = i18n.language;
    const { openMenuItem } = useOpenMenuItem();
    const badges = resolveItemBadges(item, menuStore.badgesById);
    const menuCategory = menuStore.categories.find(category => category.id === item.data.menuCategoryId);

    const buttonsColor = menuStore?.menu?.data?.themeSettings?.buttonsBackgroundColor
    const isCartEnabled = menuStore?.menu?.data?.isCartEnabled
    const oldPriceLabel = useOldPriceLabel();


    const onPlusClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (item.data.menuItemModifierSets.length === 0) {
            cartStore.addItem(item, [], 1);
        } else {
            openMenuItem(item);
        }
    }

    const showModalWindow = () => {
        openMenuItem(item);
    };


    let price: number;
    if (item.data.sellPrice.price === 0) {
        price = menuStore.getMinPrice(item);
    } else {
        price = item.data.sellPrice.price;
    }


    let classes = [styles.badgeWithTime];
    if (badges.inline.length > 0) {
        classes.push(styles.withBadges);
    }

    // Плашка с подписью выше строки актуальной цены — карточке нужен запас снизу.
    const hasOldPriceLabelBadge = !isInCart && !!oldPriceLabel
        && !!item.data.oldPrice && item.data.oldPrice.price > 0;

    return <div
        className={classNames(styles.menuItemContainer, {
            [styles.withOldPriceLabel]: hasOldPriceLabelBadge
        })}
        onClick={showModalWindow}
    >
        <div className={styles.imgContainer}>
            <div>
                <LazyImage
                    type={MediaType.preview}
                    media={item.data.media}
                    asCarousel={true}
                    maxHeight={'200px'}
                />

                <div className={classNames(styles.newBadgeImg, {
                    [styles.withSupplierLogo]: !!item.data.supplierLogoUrl
                })}>
                    <ItemBadges badges={badges.overPhoto}/>
                </div>

                {item.data.supplierLogoUrl && (
                    <div className={styles.supplierLogo}>
                        <img style={{ maxHeight: 50, maxWidth: 50, borderRadius: 10 }} src={`${item.data.supplierLogoUrl}`} alt=""/>
                    </div>
                )}
            </div>
        </div>
        <div className={styles.content}>
            <div className={classes.join(" ")}>

                <div>
                    <ItemBadges badges={badges.inline}/>
                </div>
                {
                    (item.data.cookingTimeFromCategory && menuCategory && menuCategory.data.categoryCookingTime.fromTime) &&
                    <div className={styles.cookingTime}>
                        <img src={time} alt=""/>
                        <Trans i18nKey="menu:min" values={{
                            from: menuCategory.data.categoryCookingTime.fromTime,
                            to: menuCategory.data.categoryCookingTime.toTime
                        }}/>
                    </div>
                }
                {
                    (!item.data.cookingTimeFromCategory && item.data.itemCookingTime.fromTime) &&
                    <div className={styles.cookingTime}>
                        <img src={time} alt=""/>
                        <Trans i18nKey="menu:min" values={{
                            from: item.data.itemCookingTime.fromTime,
                            to: item.data.itemCookingTime.toTime
                        }}/>
                    </div>
                }
            </div>

            <p className={styles.title}>{item.data.name[locale]}</p>
            <p className={styles.description}>
                {item.data.description[locale]}
            </p>
        </div>
        {item.data.arCodeLink && (
            <div style={{
                bottom: 5,
                marginBottom: 10,
                minWidth: "100%",
            }}>
                <div
                    style={{
                        maxWidth: "200px",
                        width: "100%",
                        background: "rgba(247, 247, 247, 0.1)",
                        backdropFilter: "blur(2px)",
                    }}
                    onClick={(event) => {
                        window.open(item.data.arCodeLink || "")
                        event.stopPropagation()
                    }}
                >
                    <div
                        style={{
                            background: "linear-gradient(90deg, #ff48b6 0%, #ffb660 51.84%, #FFDE69 100%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            textAlign: "center",
                            borderRadius: 10,
                            color: "#ffffff",
                            padding: "10px 10px",
                            margin: "0 5px"
                        }}
                    >
                        <img src={Icon3d} alt=''/>
                        <div style={{fontWeight: 500, fontSize: '11pt'}}>
                            Доступно в
                        </div>
                        <div style={{fontWeight: 700, fontSize: '16pt'}}>
                            3D
                        </div>
                    </div>
                </div>
            </div>
        )}
        <div style={{
            padding: "0 5px",
            marginTop: 5,
            position: "absolute",
            bottom: 5,
            minWidth: "100%",
            boxSizing: "border-box"
        }}>
            {!isInCart && item.data.oldPrice && item.data.oldPrice.price > 0 && (
                oldPriceLabel
                    ? <OldPriceLabelBadge label={oldPriceLabel} item={item.data.oldPrice}/>
                    : <FlexRowSpaceBetween>
                        <PriceComponent crossed={true} item={item.data.oldPrice}/>
                    </FlexRowSpaceBetween>
            )}
            {
                !isInCart ? <FlexRowSpaceBetween>
                        <PriceComponent item={{
                            price: price,
                            currencyId: item.data.sellPrice.currencyId
                        }}
                        />
                        {
                            isCartEnabled ? <PlusPrimaryPinkButton background={buttonsColor} onClick={onPlusClick}/> : <></>
                        }

                    </FlexRowSpaceBetween>
                    :
                    <div>
                        <p className={styles.priceHint}>
                            {(price / 100).toFixed(price % 100 > 0 ? 2 : 0)} {t("general:currency.rub")}
                        </p>
                        <div style={{ display: "flex", justifyContent: "space-around" }}>
                            <PlusMinusWidget menuItem={item} index={0} onCartPage={false}/>
                        </div>
                    </div>
            }

        </div>
    </div>
};

export default observer(MenuItemComponent);
